import React from 'react';
import { Colors } from '../../constants/colors';

export const ArrowRightIcon = ({ color = Colors.white, size = 50 }: { color?: string, size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.3093 12.7551L18.0593 25.1276L30.3093 37.5" stroke={color} strokeWidth="3" strokeLinecap="round"
          strokeLinejoin="round" />
  </svg>
);
